import { useState, useEffect } from "react";
import axios from "axios";

import "./WeatherForecast.css";
import WeatherForecastDay from "./WeatherForecastDay";

export default function WeatherForecast(props) {
  const [forecast, setForecast] = useState({ ready: false });
  const [unit, setUnit] = useState("metric");

  useEffect(() => {
    setForecast({ ready: false });
  }, [props.city]);

  function handleResponse(response) {
    setForecast({
      ready: true,
      data: response.data.daily,
    });
  }

  function fetchApiData() {
    const sheCodesApiKey = "tb3fa10906d8aeb018ofce8736864bb2";
    let apiUrl = `https://api.shecodes.io/weather/v1/forecast?query=${props.city}&key=${sheCodesApiKey}&units=metric`;

    axios.get(apiUrl).then(handleResponse);
  }

  function showFahrenheit(event) {
    event.preventDefault();
    setUnit("imperial");
  }

  function showCelsius(event) {
    event.preventDefault();
    setUnit("metric");
  }

  function changeUnit() {
    if (unit === "metric") {
      return (
        <a href="/" onClick={showFahrenheit}>
          Change forecast to Fahrenheit
        </a>
      );
    } else {
      return (
        <a href="/" onClick={showCelsius}>
          Change forecast to Celsius
        </a>
      );
    }
  }

  if (forecast.ready) {
    return (
      <div className="WeatherForecast">
        <div className="container mt-5">
          <div className="row ">
            {forecast.data.map(function (dailyForecast, index) {
              if (index < 6) {
                return (
                  <div className="col-2" key={index}>
                    <WeatherForecastDay data={dailyForecast} unit={unit} />
                  </div>
                );
              } else {
                return null;
              }
            })}
          </div>
          <div className="forecast-link me-3">{changeUnit()}</div>
        </div>
      </div>
    );
  } else {
    fetchApiData();
    return <div>Loading forecast...</div>;
  }
}
